import UnsubscribeScreen from "./UnsubscribeScreen";

export default UnsubscribeScreen;
